// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spacer-2[data-v-ee523af0]{height:2rem}.buttons[data-v-ee523af0]{display:flex;justify-content:flex-end;gap:.5rem}p[data-v-ee523af0]{font-size:.9rem;color:var(--color-text-secondary)}", ""]);
// Exports
module.exports = exports;
